import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CheckPermission, ModalFilterUser } from "../../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../../context";
import { AbsenceApi, AbsenceExport } from "../../../api";
import { convertDateToString, converDurationToMin, calculateDifferenceTwoDay, convertStringDateToDateSupport } from "../../../utils";
import { useSearchParams } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

export const Absence = () => {
    const CtxNav = useContext(ContextNav)
    const CtxAbs = useContext(ContextAbsence)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleUser, setVisibleUser] = useState<boolean>(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [tableData, setTableData] = useState<any>([])
    const [total, setTotal] = useState<any>(null)
    const col: any = [
        {
            title: "کارمند ",
            render: (i: any) => (<div className="h-[40px] flex items-center">{i.user && i.user != null && i.user}</div>)
        },
        {
            title: "تاریخ غیبت ",
            render: (i: any) => (<>{i.from && i.from != null && new Date(i.from).toLocaleDateString('fa-Ir')}</>)
        },
        {
            title: "مدت غیبت  ",
            render: (i: any) => (<>{i.duration && i.duration != null && converDurationToMin(i.duration)}</>)
        },
        {
            title: "نوع غیبت ",
            render: (i: any) => (<>
                {i.type && i.type != null && i.type == 1 && "ساعتی"}
                {i.type && i.type != null && i.type == 2 && "روزانه"}
            </>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
    ]

    const exportFile = async (type: string) => {
        const res: any = await AbsenceExport(CtxAbs.jsonParmsAbsence, type)
        var el = document.createElement("a");
        el.setAttribute("href", res);
        el.setAttribute("download", type == 'csv' ? 'export.csv' : 'export');
        el.setAttribute("target", '_blank');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }

    const changePage = (type: string) => {
        let data = { ...CtxAbs.jsonParmsAbsence };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        CtxAbs.setJsonParmsAbsence(data)
        getData(data)
    }

    const handelSelectUsers = (userId: any) => {
        let data = { ...CtxAbs.jsonParmsAbsence };
        if (data['user']) {
            if (data['user'].indexOf(userId) == -1) {
                data['user'].push(userId)
            }
            else {
                data['user'].splice(data['user'].indexOf(userId), 1)
            }
        }
        else {
            data['user'] = [userId];
        }
        CtxAbs.setJsonParmsAbsence(data)
    }

    const handelFilterUser = () => {
        setVisibleUser(false)
        getData(CtxAbs.jsonParmsAbsence)
    }

    const handelSelect = (e: any, name: any) => {
        let data = { ...CtxAbs.jsonParmsAbsence };
        let active = { ...CtxAbs.activeFilterAbsence };
        if (e.target.value != 'all') {
            data[name] = e.target.value;
            active[name] = e.target.value;
        }
        else {
            delete data[name];
            active[name] = -1;
        }
        CtxAbs.setJsonParmsAbsence(data)
        CtxAbs.setActiveFilterAbsence(active)
        getData(data)
    }



    const handelSelectCustomTime = (e: any, type: string) => {
        let data = { ...CtxAbs.jsonParmsAbsence };
        let active = { ...CtxAbs.activeFilterAbsence };
        if (type == 'from') {
            data['from'] = convertStringDateToDateSupport(e?.toDate?.().toString());
            active['startCalender'] = new Date(e?.toDate?.().toString());
        }
        else if (type == 'to') {
            data['to'] = convertStringDateToDateSupport(e?.toDate?.().toString());
            active['endCalender'] = new Date(e?.toDate?.().toString());
        }
        CtxAbs.setJsonParmsAbsence(data)
        CtxAbs.setActiveFilterAbsence(active)
        getData(data)
    }

    const handelSelectPeriod = (value: any) => {
        let data = { ...CtxAbs.jsonParmsAbsence };
        let active = { ...CtxAbs.activeFilterAbsence };
        data['from'] = value[0].from;
        data['to'] = value[0].to;
        active['activePeriod'] = value[1]
        active['startCalender'] = new Date(value[0].from);
        active['endCalender'] = new Date(value[0].to);
        CtxAbs.setJsonParmsAbsence(data)
        CtxAbs.setActiveFilterAbsence(active)
        getData(data)
    }

    const getData = async (parms: any) => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await AbsenceApi(parms)
            setTableData(res.data.absences.data)
            setTotal(res.data.total_absence)
            CtxLoad.setDisplayLoadingSkelton(false)
            setCurrentPage(res.data.current_page)
            setLastPage(res.data.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "غیبت | دایان"
        CtxNav.setActiveMenuItem({ 'item': 1, 'subItem': 4, })
        getData(CtxAbs.jsonParmsAbsence)

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">غیبت‌های پرسنل</h1>

            {CheckPermission(22) &&
                <>
                    <div className=" w-full flex flex-wrap items-center">
                        <div className=" w-full  flex flex-wrap sm:flex-nowrap items-center pl-0 md:pl-2 justify-between">
                            <div onClick={() => { setVisibleUser(true) }} className="w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow px-[15px] sm:text-[13px] text-[11px] flex items-center  cursor-pointer">
                                <span>{CtxAbs.jsonParmsAbsence?.user.length == 0 && 'انتخاب کارمند'}</span>
                                <span>{CtxAbs.jsonParmsAbsence?.user.length > 0 && `${CtxAbs.jsonParmsAbsence?.user.length} کارمند انتخاب شد`}</span>
                            </div>
                            <div className=" w-[49%] h-[40px] sm:h-[50px]  bg-white rounded-md shadow text-sm">
                                <CSelect defaultValue={CtxAbs.activeFilterAbsence.type != -1 ? CtxAbs.activeFilterAbsence.type : ""} placeholder={'نوع غیبت'} onChange={(e: any) => handelSelect(e, 'type')} >
                                    <option value={'all'}>همه</option>
                                    <option value={1}>ساعتی</option>
                                    <option value={2}>روزانه</option>
                                </CSelect>
                            </div>
                        </div>
                    </div>

                    <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                        <div className="w-full md:w-fit flex items-center">
                            <div className="   hidden md:flex items-center pl-2">
                                <div onClick={() => exportFile('csv')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer">
                                    <svg x="0px" y="0px" viewBox="0 0 548.29 548.291" className={`  h-7 fill-white `}>
                                        <use xlinkHref="/assetes/svg/csv.svg#csv" />
                                    </svg>
                                </div>
                                <div onClick={() => exportFile('excel')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer mr-2">
                                    <svg x="0px" y="0px" viewBox="0 0 26 26" className={`  h-7 fill-green-800 `}>
                                        <use xlinkHref="/assetes/svg/excel.svg#excel" />
                                    </svg>
                                </div>
                            </div>
                            <div className=" w-full md:w-[240px] flex flex-col">
                                <ReportSelectPeriod onChange={(value: any) => handelSelectPeriod(value)} activeTab={CtxAbs.activeFilterAbsence.activePeriod} />
                                <div className=" w-full flex   mt-2">
                                    <div className="jalali-datePicker w-full h-[30px] ml-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px] relative group">
                                        <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ شروع</div>
                                        <DatePicker calendar={persian} locale={persian_fa} value={CtxAbs.activeFilterAbsence?.startCalender} onChange={(e: any) => { handelSelectCustomTime(e, 'from') }} />
                                    </div>
                                    <div className="jalali-datePicker w-full h-[30px] mr-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px] relative group">
                                        <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ پایان</div>
                                        <DatePicker calendar={persian} locale={persian_fa} value={CtxAbs.activeFilterAbsence?.endCalender} onChange={(e: any) => { handelSelectCustomTime(e, 'to') }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                            <button onClick={() => exportFile('csv')} className="w-full md:w-[120px] h-[30px] md:h-[40px] md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">CSV</button>
                            <button onClick={() => exportFile('excel')} className="w-full md:w-[120px] h-[30px] md:h-[40px] mx-1 md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">اکسل</button>
                        </div>
                    </div>
                </>
            }

            {CheckPermission(22) &&
                <div className=" w-full mt-[20px]">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} >
                            <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
                        </TablePage>
                        :
                        <CSkeletonTable />
                    }
                </div>
            }

            {CheckPermission(22) &&
                <>
                    {total != null && tableData?.length > 0 &&
                        <div className=" w-full my-[40px] px-3 flex flex-col rounded-lg overflow-hidden table-report-shadow bg-[#f8f8f8]">
                            <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                                مجموع غیبت : {converDurationToMin(total)}
                            </div>
                        </div>
                    }
                </>
            }

            <ModalFilterUser visible={visibleUser} setVisible={setVisibleUser} onOk={handelFilterUser} listUser={CtxDash.employees} listSelected={CtxAbs.jsonParmsAbsence?.user} selectUser={handelSelectUsers} />

        </div>
    )
}
